export default __webpack_public_path__ + "static/media/103.5cc5d485.jpg";